export const WHATSAPP_URL =
  "https://wa.me/49794133514?text=Hallo%20TTS%20Britz%2C%20ich%20habe%20Ihre%20Website%20besucht%20und%20m%C3%B6chte%20eine%20Anfrage%20stellen.";

export type WhatsAppLinkLocation = "floating_button" | "contact_section";

export function trackWhatsAppClick(linkLocation: WhatsAppLinkLocation) {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "whatsapp_click",
    page_path: `${window.location.pathname}${window.location.search}`,
    link_location: linkLocation,
  });
}
